<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import SupplierFormModal from "@/components/modals/supplier-form.vue";

export default {
    name: "SupplierModal",
    components: {
        SupplierFormModal,
    },
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "sortName",
            sortDesc: false,
            fields: [
                {
                    key: "name",
                    sortable: true,
                    label: "Client",
                    thStyle: { width: "85%" },
                },

                {
                    key: "actions",
                },
            ],
            indexSelected: -1,
            tableBusy: false,
        };
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
    },
    validations: {
        form: {
            name: { required },
            address: { required },
            tin: { required },
            email: { required },
            contactNumber: { required },
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addSupplier() {
            this.$refs.supplierFormModal.onReset();
            this.$refs.supplierFormModal.modalTitle = "Create New Client";
            this.$bvModal.show("supplier-form-modal");
        },
        hideModal() {
            this.$bvModal.hide("p-modal");
        },
        onCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            } else {
                if (this.form.id > 0) {
                    this.$store
                        .dispatch("supplier/UpdateSupplier", this.form)
                        .then((res) => {
                            this.tableData.splice(
                                this.indexSelected,
                                1,
                                res.data
                            );
                            this.$bvModal.hide("p-modal");
                            this.showToast("Successfully updated!","success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!","error");
                        });
                } else {
                    this.$store
                        .dispatch("supplier/CreateSupplier", this.form)
                        .then((res) => {
                            this.tableData.push(res.data);
                            this.$bvModal.hide("p-modal");
                            this.showToast("Successfully created!","success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!","error");
                        });
                }
                this.submitted = false;
            }
        },
        updateItem(props) {
            this.$refs.supplierFormModal.updateItem(props.item);
            this.indexSelected = this.tableData.indexOf(props.item);
            this.$refs.supplierFormModal.modalTitle = "Update Client";
            this.$bvModal.show("supplier-form-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("supplier/DeleteSupplier", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast("Successfully deleted!","success");
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        updateTable($event){
            if($event.type === 'add'){
                this.tableData.push($event.data);
                this.showToast("Successfully created!", "success");
            }else{
                this.tableData.splice(this.indexSelected, 1, $event.data);
                this.showToast("Successfully updated!", "success");
            }
            this.$bvModal.hide("supplier-form-modal");
        },
        dropData(data) {
            this.$emit("dropData", data[0]);
            this.$bvModal.hide("supplier-modal");
        },
    },
    async created() {
        this.tableBusy = false;
        await this.$store
            .dispatch("supplier/GetSupplier")
            .then((res) => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, "error");
                }
                res.data.map(item => {
                    item.sortName = item.name.replace(' - ', 'a').replace('-', '').replace('–', '').replace(':', '1').replace(/'/g, '').replace(/\s+/g,'').replace(/[\r\n]/gm, '').trim()
                })
                this.tableData = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!","error");
            });
        this.tableBusy = false;
    },
};
</script>

<template>
    <b-modal
        id="supplier-modal"
        title="Client List"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row mt-1">
            <div class="col-sm-12 col-md-8">
                <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm mx-2 w-75"
                        ></b-form-input>
                        <b-form-select
                            class="form-select form-select-sm w-25"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                    </label>
                </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-4">
                <div class="d-flex justify-content-end align-items-center">
                    <button
                        type="button"
                        @click="addSupplier"
                        class="btn btn-sm btn-info d-flex align-items-center"
                    >
                        <i class="bx bx-plus fs-6"></i>Create New
                    </button>
                    
                </div>
            </div>
            <!-- End search -->
        </div>
        <div class="table-responsive mb-0">
            <b-table
                class="datatables"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="tableBusy"
                @filtered="onFiltered"
                bordered
                outlined
                hover
                striped
                show-empty
                select-mode="single"
                selectable
                @row-selected="dropData"
                selected-variant="success"
            >
                <template #empty="scope">
                    <div class="text-center">{{ scope.emptyText }}</div>
                </template>
                <template #table-busy>
                    <div
                        class="d-flex justify-content-center align-items-center"
                    >
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #cell(actions)="row">
                    <div class="float-end">
                        <b-dropdown
                            id="dropdown-dropleft"
                            right
                            variant="link"
                            toggle-class="text-decoration-none"
                            menu-class="dropdown-menu-end"
                            no-caret
                        >
                            <template #button-content>
                                <i class="fas fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item
                                @click="updateItem(row)"
                                variant="secondary"
                                ><i class="mdi mdi-update font-size-18 me-1"></i
                                >Edit</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="deleteItem(row)"
                                variant="danger"
                                ><i
                                    class="mdi mdi-trash-can font-size-18 me-1"
                                ></i
                                >Delete</b-dropdown-item
                            >
                        </b-dropdown>
                    </div>
                </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
        <SupplierFormModal ref="supplierFormModal" @update-table="updateTable"></SupplierFormModal>
    </b-modal>
</template>
